import { BrowserView } from 'components/DeviceDetect'
import React, { Fragment } from 'react'
import useCart from 'store/CartProvider'
import useProduct from 'store/SingleProductProvider'
import { ProductPrice as StyledProductPrice } from './MainInfo/MainInfo.style'

export default function ProducPrice(props) {
  const {
    product: { old_price },
    productPrice,
    installmentPrice,
    inStock,
  } = useProduct()
  const { payMethod } = useCart()

  const hidePriceOnInstallment =
    props.hidePriceOnInstallment && payMethod === 'installment'

  return (
    <StyledProductPrice
      itemProp="offers"
      itemScope
      itemType="https://schema.org/Offer"
      style={
        props.Browser
          ? {
              borderBottom: '1px solid #E5E5E5',
              paddingBottom: ' 20px',
              marginBottom: '-20px',
            }
          : {}
      }
    >
      {inStock && (
        <BrowserView>
          <h4>ფასი:</h4>
        </BrowserView>
      )}
      <h2>
        {inStock && !hidePriceOnInstallment && (
          <span className="saled">
            <span className="priceMain" itemProp="price" content={productPrice}>
              {productPrice}
            </span>
            <span className="balls" itemProp="priceCurrency" content="GEL">
              ₾
            </span>
            <link itemProp="availability" href="https://schema.org/InStock" />
          </span>
        )}
        {!inStock && (
          <Fragment>
            <link
              itemProp="availability"
              href="https://schema.org/OutOfStock"
            />
            <span className="saled">არ არის მარაგში</span>
          </Fragment>
        )}
        {old_price && inStock ? (
          <Fragment>
            <span className="original">
              <span className="price">{old_price}₾</span>
            </span>
          </Fragment>
        ) : null}
      </h2>
      {installmentPrice && inStock ? (
        <h3>
          განვადებით <span>{installmentPrice}₾</span> თვეში
        </h3>
      ) : null}
    </StyledProductPrice>
  )
}
